import React from 'react'
import { updateFederationPresident } from '../../../Apis/federations';
import Form from './Form';

export default function FederationUpdatePresident(props) {
  // onsubmit
  const onSubmit = async (e, data) => {
    e.preventDefault();
    //to send request
    return await updateFederationPresident(props.federationId, { ...data, "_method": "patch" }).then(res => {
      props.getNewData()
      return 'done';
    }).catch(err => {
      return err.response.data.errors;
    })
  };

  return (
    <div className="modal-dialog modal-dialog-centered">
      {props.data && <Form onSubmit={onSubmit} id='update' federationId={props.federationId} data={props.data} />}
    </div>
  )
}
